import { checkParams } from './../../components/Utils'
import { validateParamURL } from './../colors'

export const handleRangePrimaryColor = async (ev, state, props) => {  
  
  const { history, location, match } = props

  let primaryColorParam = checkParams('primary-color', location)
  let secondaryColorParam = checkParams('secondary-color', location)
  let tertiaryColorParam = checkParams('tertiary-color', location)
  let primaryColorSelected = 0

  
  if (state && state.primaryColors) {
    
    const sendTo = `/${match.params.wizardId}?primary-color=${primaryColorSelected}&step=1`
    
    const errorValueParam = validateParamURL(state.primaryColors, sendTo, history, primaryColorParam)
    
    if(errorValueParam) {
      return { primaryColorSelected }
    }
  }

  if (ev) {
    primaryColorSelected = parseInt(ev.target.value)
  }
  
  else if (primaryColorParam) {
    primaryColorSelected = parseInt(primaryColorParam)
  }
  
  else if (primaryColorParam === 'undefined') {
    history.push(`/${match.params.wizardId}`)
  }
  
  if (!secondaryColorParam || !tertiaryColorParam || ev) {
    history.push(`/${match.params.wizardId}?primary-color=${primaryColorSelected}`)
  }
  

  return {
    primaryColorSelected
  }

}